const dev = {
	API_ENDPOINT_URL:
		"http://landf-app-zd-api-dev-1452429562.eu-west-1.elb.amazonaws.com/api",
	S3_UPLOAD_URL:
		"https://landf-app-supplier-uploads.s3.eu-west-1.amazonaws.com",
	COGNITO_POOL_ID: "eu-west-1_k0OXSk8KR",
	COGNITO_CLIENT_ID: "7n1t162ip1mf6k75knu8v5notm",
};

const test = {
	API_ENDPOINT_URL: "https://portal-qa-api.lockmanager.com/api",
	S3_UPLOAD_URL:
		"https://landf-app-supplier-uploads.s3.eu-west-1.amazonaws.com",
	COGNITO_POOL_ID: "eu-west-1_neINxKSBG",
	COGNITO_CLIENT_ID: "6mg0q2gf93tq9urlgpkrrqss9t",
};

const prod = {
	API_ENDPOINT_URL: "https://portal-api.lockmanager.com/api",
	S3_UPLOAD_URL:
		"https://landf-app-supplier-uploads.s3.eu-west-1.amazonaws.com",
	COGNITO_POOL_ID: "eu-west-1_C3bsoWfjv",
	COGNITO_CLIENT_ID: "4437n4diiedkdb1lsphnf6lufi",
};

const getEnv = () => {
	switch (process.env.REACT_APP_ENV) {
		case "development":
			return dev;
		case "production":
			return prod;
		case "test":
			return test;
		default:
			break;
	}
};

export const env = getEnv();
